var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 260,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-cover_svg__clip0_7310_462156)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000729",
    d: "M0 0h480v260H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    rx: 400,
    ry: 200,
    fill: "url(#default-cover_svg__paint0_diamond_7310_462156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.78-85.734l101.438-101.438 94.954 94.954L555.733 9.22l-1.414 1.414 1.414 1.414 101.429 101.429-94.934 93.704L460.78 105.733l-1.414-1.414-1.414 1.414-101.438 101.439-93.686-93.686L364.267 12.048l1.414-1.414-1.414-1.414L262.819-92.228l93.704-94.934L457.952-85.734l1.414 1.415 1.414-1.415z",
    stroke: "url(#default-cover_svg__paint1_linear_7310_462156)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 250c0 109.726-88.274 198-198 198s-198-88.274-198-198S-89.726 52 20 52s198 88.274 198 198zm-262.42 0c0 35.505 28.915 64.421 64.42 64.421S84.42 285.505 84.42 250c0-35.505-28.915-64.421-64.42-64.421S-44.42 214.495-44.42 250z",
    stroke: "url(#default-cover_svg__paint2_linear_7310_462156)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-cover_svg__filter0_f_7310_462156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.398 83.197C111.359 73.4 92.135 63.105 75 60.397",
    stroke: "url(#default-cover_svg__paint3_linear_7310_462156)",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.799 82.597C112.666 73.467 92.022 63.62 75 60.397",
    stroke: "url(#default-cover_svg__paint4_linear_7310_462156)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 21.385,
    cy: 9.02,
    rx: 21.385,
    ry: 9.02,
    transform: "scale(-1 1) rotate(-22.442 109.96 347.95)",
    fill: "url(#default-cover_svg__paint5_diamond_7310_462156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-cover_svg__paint1_linear_7310_462156",
    x1: 498.717,
    y1: -276.571,
    x2: 335.729,
    y2: 210.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#0177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0177FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0177FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-cover_svg__paint2_linear_7310_462156",
    x1: -180,
    y1: 250,
    x2: 220,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#07F",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-cover_svg__paint3_linear_7310_462156",
    x1: 75,
    y1: 61.417,
    x2: 123.272,
    y2: 85.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#B7DBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-cover_svg__paint4_linear_7310_462156",
    x1: 75,
    y1: 61.422,
    x2: 122.319,
    y2: 85.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#B7DBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DBFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "default-cover_svg__paint0_diamond_7310_462156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 200 -400 0 240 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0009B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000566",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "default-cover_svg__paint5_diamond_7310_462156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 9.01954 -21.3848 0 21.385 9.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "default-cover_svg__clip0_7310_462156"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v260H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "default-cover_svg__filter0_f_7310_462156",
    x: 66.688,
    y: 50.422,
    width: 67.855,
    height: 42.415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_7310_462156"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgDefaultCover as ReactComponent };